import React from "react";
import { AppRouteProps } from "@harea/component";

const PlanListContainer = React.lazy(() => import("./container/PlanListContainer"));

export const PricingsRoutes: Array<AppRouteProps> = [
    {
        path: "pricings",
        title: "Harea.Billing.Subscription.Pricings.Title",
        roles: ["VIEW_SUBSCRIPTION"],
        element: <PlanListContainer />,
    },
];
